import { render, staticRenderFns } from "./shopForeignList.vue?vue&type=template&id=c85c7b82&scoped=true"
import script from "./shopForeignList.vue?vue&type=script&lang=js"
export * from "./shopForeignList.vue?vue&type=script&lang=js"
import style0 from "./shopForeignList.vue?vue&type=style&index=0&id=c85c7b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85c7b82",
  null
  
)

export default component.exports